// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"Scrollbar_horizontal__22rXD","vertical":"Scrollbar_vertical__3YB07"};